const footprintClassNamesMap = {
  button: '.fp-button',
  input: '.fp-input',
  pinInput: '.fp-pin-input',
  checkbox: '.fp-checkbox',
  label: '.fp-label',
  hint: '.fp-hint',
  linkButton: '.fp-link-button',
  link: 'a',
  pageHeader: '.fp-page-header',
  pageHeaderTitle: '.fp-page-header-title',
  pageHeaderSubtitle: '.fp-page-header-subtitle',
};

export default footprintClassNamesMap;
